module.exports = __webpack_public_path__ + "static/media/tanzania-map-on.3f069f93.png";